import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormSetupComponent } from '../../../shared/component/form-setup/form-setup.component';
import { edit_amr_config, edit_appliances, edit_features, edit_site_charges, edit_sitedetail, edit_supportinfo } from '../../../shared/services/formJson';
import { Country } from 'country-state-city';
import { ApiCallsService } from '../../../shared/services/api-calls.service';
import { ToastService } from '../../../shared/services/toast.service';

@Component({
  selector: 'app-edit-site',
  standalone: true,
  imports: [CommonModule, NgbModule, FormSetupComponent, 
    // SvgIconComponent
  ],
  templateUrl: './edit-site.component.html',
  styleUrl: './edit-site.component.scss'
})
export class EditSiteComponent implements OnInit {
ngOnInit(): void {
  const urlParams = new URLSearchParams(window.location.search);
  const siteNameFromUrl = urlParams.get('id'); // string | null

  if (siteNameFromUrl) {
    this.siteId = atob(siteNameFromUrl); // Safe now ✅
    // window.location.reload();
  } 
}


  siteId:string = ''
// Replace single boolean
// callForForm: boolean = false;
  formTriggers: { [id: string]: boolean } = {};
  constructor(private cdr: ChangeDetectorRef,private apiService:ApiCallsService,private toast : ToastService) {}
  activeForms: { [key: string]: any[] } = {};

  accordionData = [
  { id: 'basic_detail', icon: 'site_details', title: 'Site Detail', apiUrl: '/SiteBasicDetails', formConfig: edit_sitedetail },
  { id: 'support_info',icon : 'supportinfo', title: 'Support Information', apiUrl: '/SiteSupportInfo', formConfig: edit_supportinfo ,detail: {
  tab: [
    {
      id: 1,
      header: "Supervisor Details",
      item: [
        {
          label: "Name",
          value: "---"
        },
        {
          label: "Contact No.",
          value: "---"
        },
        {
          label: "Email-ID",
          value: "---"
        }
      ]
    },
    {
      id: 2,
      header: "Engineer",
      item: [
        {
          label: "Name",
          value: "---"
        },
      ]
    }
  ]
}
  },
  { id: 'features', icon: 'features', title: 'Features', apiUrl: '/SiteFeatures', formConfig: edit_features },
  { id: 'amr_config', icon: 'amr_config', title: 'AMR Configuration', apiUrl: '/SiteAMRConfig', formConfig: edit_amr_config },
  { id: 'site_charges', icon: 'site_charges', title: 'AMR Site Charges', apiUrl: '/SiteSiteCharges', formConfig: edit_site_charges },
  { id: 'appliances', icon: 'appliances', title: 'Appliances', apiUrl: '/SiteAppliances', formConfig: edit_appliances }
  ];



  triggerForm(formId: string) {
    // //console.log("🔔 Triggering validation for:", formId);
    this.formTriggers[formId] = true;

    // reset back to false after a tick so next click works
    setTimeout(() => {
      this.formTriggers[formId] = false;
    }, 0);
  }
  private patchNestedFormValues(formConfig: any[], apiData: any[]) {
    formConfig.forEach(fc => {
      if (fc.tabs) {
        // inside tabs
        fc.tabs.forEach((tab: any) => this.patchNestedFormValues(tab.children, apiData));
      } else if (fc.children) {
        // inside groups
        this.patchNestedFormValues(fc.children, apiData);
      } else if (fc.id) {
        if (fc.type === 'checkbox' && Array.isArray(fc.options)) {
          // Special case: checkboxes → assign full array of {key, value}
          const mapped = apiData
            .filter(d => fc.options.some((opt: any) => opt.id === d.key))
            .map(d => ({ key: d.key, value: d.value, readonly: d.readonly ?? false }));

          fc.existingValue = mapped;
          
        } else {
          // Normal fields (text, dropdown, etc.)
          const match = apiData.find(d => d.key === fc.id);
          if (match) {
            fc.existingValue = match.value ?? '';
            if (match.readonly !== undefined) {
              fc.readonly = match.readonly;
            }
          }
        }
      }
    });
  }

  private patchFormValues(formConfig: any[], apiData: any[]) {
    apiData.forEach(apiItem => {
      const field = formConfig.find(fc => fc.id === apiItem.key);
      if (field) {
        field.existingValue = apiItem.value ?? '';
        console.log(field);
        
        if (apiItem.readonly !== undefined) {
          field.readonly = apiItem.readonly;
        }
      }
    });
  }
  itemCall(item: any) {
  // Skip if already active
  if (this.activeForms[item.id]) return;

  // Deep clone config to avoid mutation
  this.activeForms[item.id] = JSON.parse(JSON.stringify(item.formConfig));

  // 1️⃣ Populate API options first
  this.apiService.populateApiOptions(this.activeForms[item.id]).subscribe({
    next: () => {
      // 2️⃣ Then fetch form fill data
      this.apiService.formfilldata(item.apiUrl, this.siteId).subscribe({
        next: (res: any) => {
          const data = res?.Data || res?.data || [];

          switch (item.id) {
            case 'basic_detail':
              this.injectCountriesIfNeeded(this.activeForms['basic_detail']);
              this.patchNestedFormValues(this.activeForms[item.id], data);
              break;

            case 'support_info':
              this.handleSupportInfoPopulation(data);
              this.patchFormValues(this.activeForms[item.id], data);
              break;

            default:
              this.patchFormValues(this.activeForms[item.id], data);
          }

          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error(`❌ Error fetching form fill data for ${item.id}:`, err);
        },
      });
    },
    error: (err) => {
      console.error(`❌ Error populating API options for ${item.id}:`, err);
    },
  });
}

private handleSupportInfoPopulation(data: any[]) {
  const supervisorName = data.find(x => x.key === 'supervisor_name')?.value || '---';
  const supervisorContact = data.find(x => x.key === 'supervisor_contact_no')?.value || '---';
  const supervisorEmail = data.find(x => x.key === 'supervisor_email_id')?.value || '---';
  const engineerName = data.find(x => x.key === 'name3')?.value || '---';

  const supportTab = this.accordionData.find((a: any) => a.id === 'support_info');
  if (!supportTab?.detail?.tab) return;

  const supervisorTab = supportTab.detail.tab.find((t: any) => t.header === 'Supervisor Details');
  const engineerTab = supportTab.detail.tab.find((t: any) => t.header === 'Engineer');

  if (supervisorTab?.item) {
    supervisorTab.item.find(i => i.label === 'Name')!.value = supervisorName;
    supervisorTab.item.find(i => i.label === 'Contact No.')!.value = supervisorContact;
    supervisorTab.item.find(i => i.label === 'Email-ID')!.value = supervisorEmail;
  }

  if (engineerTab?.item) {
    engineerTab.item.find(i => i.label === 'Name')!.value = engineerName;
  }
}



  injectCountriesIfNeeded(formConfig: any[]): void {

    const countries = Country.getAllCountries().map(c => ({
      id: c.isoCode,
      name: c.name
    }));

    const updateCountryField = (nodes: any[]): any[] => {
      return nodes.map(node => {
        // Case 1: Node has tabs → dig into each tab
        if (node.tabs) {
          //console.log('[injectCountriesIfNeeded] Traversing tabs...');
          return { ...node, tabs: node.tabs.map((tab: any) => ({ 
            ...tab, 
            children: updateCountryField(tab.children || []) 
          })) };
        }

        // Case 2: Node has children
        if (node.children) {
          return { ...node, children: updateCountryField(node.children) };
        }

        // Case 3: Found the country field
        if (node.id === 'country') {
          return { ...node, options: { list: countries } };
        }

        // Case 4: Leave everything else as-is
        return node;
      });
    };

    // Replace only basic_detail formConfig
    this.activeForms['basic_detail'] = updateCountryField(formConfig);

    // //console.log('[injectCountriesIfNeeded] Updated basic_detail formConfig:', this.activeForms['basic_detail']);
    this.cdr.markForCheck();
  }

  activeFormId: string | null = null;

  
  formResponses: { [id: string]: any } = {};

  formSubmit(payload: boolean, formId: string) {
    if (payload) {
      // add id field to the form data
      this.formResponses[formId] = {
        ...this.formResponses[formId],
        id: this.siteId,
        // recharge_mode: 'DIRECT'            // ✅ your hardcoded value
      };
      console.log(this.formResponses[formId]);
      
      this.apiService.editSite(this.formResponses[formId]).subscribe(res => {
        this.toast.showToast('Form is Submitted', 'colored', 6000, 'success');
      }); 
    } else {
      this.toast.showToast('All Required Fields are Not filled', 'colored', 6000, 'danger');
    }
  }

  submitformCheck(payload: { id: string; value: any }) {
  //console.log("📥 Received payload:", payload);
  // If this id already exists, merge the values
  if (this.formResponses[payload.id]) {
    this.formResponses[payload.id] = {
      ...this.formResponses[payload.id],
      ...payload.value
    };
  } else {
    this.formResponses[payload.id] = payload.value;
  }
  //console.log("📦 Combined responses:", this.formResponses);

  }
}
